import { render, staticRenderFns } from "./customSelf.vue?vue&type=template&id=069d6393&scoped=true"
import script from "./customSelf.vue?vue&type=script&lang=ts"
export * from "./customSelf.vue?vue&type=script&lang=ts"
import style0 from "./customSelf.vue?vue&type=style&index=0&id=069d6393&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069d6393",
  null
  
)

export default component.exports